import { SummaryComponent } from "./summary/summary.component";

export const ReportsRoute=[
    {
    path: 'summary/agent-activity-report/:id',
        component: SummaryComponent,
        data: {
          title: 'Summary Reports',
          urls: [{ title: 'Home', url: '/main/dashboards/dashboard3' }, { title: 'Reports' }]
        }
      }
]